module.exports = __webpack_public_path__ + "static/c4-661f85561097446e03eafba74629c6e9.jpg";